import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tab, TabH2, TabWrapper } from './styles';

class TabPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const isGazzetta = process.env.REACT_APP_SITE === 'gazzetta';
    const {
      setActiveTab, isSelected, index, label, size, isCup, isTennis, dictionary, isSubPhase, isSpecialChampionship, isShort,
    } = this.props;
    const newIndex = index.url || index;
    return (
      <Fragment>
        {!isTennis &&
          <TabWrapper
            onClick={() => setActiveTab(newIndex)}
            isCup={isCup}
            isSubPhase={isSubPhase}
            isShort={isShort}
            className={(isSelected === newIndex) ? 'scroll-li tab-active' : 'scroll-li'}
          >{isGazzetta ?
            <TabH2
              size={size}
              isActive={isSelected === newIndex}
              isCup={isCup}
              isSpecialChampionship={isSpecialChampionship}
            >
              {label}
            </TabH2>
            :
            <Tab
              size={size}
              isActive={isSelected === newIndex}
              isCup={isCup}
              isSpecialChampionship={isSpecialChampionship}
            >
              {label}
            </Tab>
          }
          </TabWrapper>
        }
        {isTennis &&
          <TabWrapper
            onClick={() => setActiveTab(newIndex)}
            isCup={isCup}
            isTennis={isTennis}
            className={(isSelected === newIndex) ? 'tab-active' : ''}
          >{isGazzetta ?
            <TabH2
              isTennis={isTennis}
              size={size}
              isActive={isSelected === newIndex}
              isCup={isCup}
            >
              {dictionary[label]}
            </TabH2>
            :
            <Tab
              isTennis={isTennis}
              size={size}
              isActive={isSelected === newIndex}
              isCup={isCup}
            >
              {dictionary[label]}
            </Tab>
          }
          </TabWrapper>
        }
      </Fragment>
    );
  }
}

TabPanel.propTypes = {
  setActiveTab: PropTypes.any,
  isSelected: PropTypes.any,
  index: PropTypes.any,
  label: PropTypes.any,
  size: PropTypes.any,
  isCup: PropTypes.bool,
  isTennis: PropTypes.bool,
  dictionary: PropTypes.any,
  isSubPhase: PropTypes.bool,
  isSpecialChampionship: PropTypes.bool,
  isShort: PropTypes.bool,
};

export default TabPanel;



// WEBPACK FOOTER //
// ./src/components/CalendarTabbar/TabPanel/index.js